/** Shared constants object */
export const SCREEN_WIDTH = 1440;
export const SCREEN_HEIGHT = 960;

/** How many castles? */
export const MAX_CASTLE_SPEED = 10;
export const CASTLE_DRAG = 0.01;
export const EDGE_PROBABILITY = 0.1;
export const EDGE_DAMAGE_PROBABILITY = 0.25;
export const ROWS_PER_TRAVEL = 12;

export const CASTLE_LOCATIONS = [
  { x: 840, y: 120 },
  { x: 840 - 240, y: 240 },
  { x: 840 + 240, y: 240 },
  { x: 840 - 360, y: 480 },
  { x: 840, y: 480 },
  { x: 840 + 360, y: 480 },
  { x: 840 - 240, y: 720 },
  { x: 840 + 240, y: 720 },
  { x: 840, y: 840 }
];

export const CASTLE_CONNECTIONS = [
  [0, 1, 1, 0, 1, 0, 0, 0, 0],
  [0, 0, 0, 1, 1, 0, 0, 0, 0],
  [0, 0, 0, 0, 1, 1, 0, 0, 0],
  [0, 0, 0, 0, 1, 0, 1, 0, 0],
  [0, 0, 0, 0, 0, 1, 1, 1, 1],
  [0, 0, 0, 0, 0, 0, 0, 1, 0],
  [0, 0, 0, 0, 0, 0, 0, 0, 1],
  [0, 0, 0, 0, 0, 0, 0, 0, 1],
  [0, 0, 0, 0, 0, 0, 0, 0, 0]
];

export const CASTLE_NAMES = [
  'Castle Windermere',
  'Mantisfort',
  "Hunter's Keep",
  'Grey Bastion',
  'Conwy Castle',
  'Darkstone',
  'High Rocks',
  'Eagletower',
  'Dolorous Gard',
  'Crâne-de-grise',
  'Château de Falaise',
  'Château de Coucy',
  'Château de dohem',
  'Karlštejn Castle',
  'Lednice Castle',
  'Harlech Castle',
  'Wartburg Castle',
  'Neuschwanstein'
];
